import { ImageShapeType } from '../../../interfaces';
import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import css from './ats-asset.module.scss';

interface AtsAssetSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  pattern?: ImageShapeType | `${Layout.PageSectionStylePattern}`;
  stretch?: boolean;
  className?: string;
}

export function AtsAssetSkeleton({ pattern, stretch, className, ...rest }: AtsAssetSkeletonProps) {
  return (
    <div
      className={classes(css.asset, css.skeleton, stretch && css.stretch, className)}
      data-pattern={pattern}
      aria-disabled="true"
      aria-label="loading"
      {...rest}
    >
      <span className={css.imageContainer} />
      <span className={css.title} />
      <span className={css.subtitle} />
    </div>
  );
}
